<template>
      <div class="orderitem" >
        <div class="orderitem-line1">
            <div class="orderitem-line1-col1"><div class="badge-red">{{orderinfo.ordertypename}}</div></div>
            <div class="orderitem-line1-col2">订单号:{{orderinfo.ordernum}}</div>
            <div class="orderitem-line1-col3"><div class="badge-grey">{{orderinfo.statusname}}</div></div>
        </div>
        <div class="orderitem-line2" v-for="item in ordergoods" :key="item.id" @click="$emit('click')">
            <div class="orderitem-line2-col1"><img :src='item.headimg' class="goodsimg" /></div>
            <div class="orderitem-line2-col2">
                  <div class="goodstitle">{{item.name}}</div>
                  <div class="goodsparent">供货商:{{orderinfo.sellername}}</div>
                  <div class="pricerow">
                      <div class="price">售价{{item.price}}</div>
                      <div class="nums">X{{item.nums}}</div>
                  </div>
            </div>
        </div>
        <div class="orderitem-line33">
          <div class="discountinfo" v-if="orderinfo.coupontotal>0">优惠抵扣:-{{orderinfo.coupontotal}}</div>
        </div>
        <div class="orderitem-line3">
            <div class="orderitem-line3-col1">共{{orderinfo.totalnums}}件商品</div>
            <div class="orderitem-line3-col2">合计<span class="price-red">¥{{orderinfo.totalmoney}}</span></div>
        </div>
        <div class="orderitem-line4" v-if="orderinfo.status==1">
          <div class="bottomcon-btn-cancel" @click="onCancel(orderinfo.id)">关闭订单</div>
          <div class="bottomcon-btn-sure" @click="goPay(orderinfo.id)">去付款</div>
        </div>
        <div class="orderitem-line4" v-else-if="orderinfo.status==3">
          <div class="logistic-style">
            <div>{{orderinfo.expresscorp}}:{{orderinfo.expressnums}}</div>
          </div>
          <div class="bottomcon-btn-sure" @click="onSure(orderinfo.id)">确认收货</div>
        </div>
      </div>
</template>
<script>
import {Dialog } from 'vant'  
export default {
  name: 'OrderItem',
  props: {
    orderinfo:Object,
    ordergoods:Array
  },
  methods: {
    goPay(orderid){
      this.$go("/orderdetail/"+orderid)
    },
    onCancel(orderid){
      this.$post("/order/cancelOrder",{orderid:orderid}).then((data)=>{
          if(data.result.success){
              this.$toast(data.result.info)
              location.reload()
          }else{
              this.$toast(data.result.info)
          }
      })
    },
    onSure(orderid){
        Dialog.confirm({
          title: '温馨提示',
          message: '确认收货后，货款将打给卖家，您确定收到商品了吗？',
        })
        .then(() => {
           this.$post("/order/onSure",{orderid:orderid}).then((data)=>{
              if(data.result.success){
                this.$toast(data.result.info)
                location.reload()
              }else{
                this.$toast(data.result.info)
              }
           })
        })
        .catch(() => {
        });
    }
  },
  components:{
      [Dialog.name]:Dialog
  }
}
</script>
<style scoped>
.orderitem{display: flex;flex-flow: column nowrap;background-color: #fff;margin-bottom: 0.25rem;border-radius: 0.1rem;}
.orderitem-line1{display: flex;align-items: center;padding: 0.3rem;border-bottom: 1px solid #e7e7e7;}
.badge-red{font-size:0.3rem;border-radius: 0.1rem;border:1px solid #ff3600;color:#ff3600;padding: 0.05rem;}
.orderitem-line1-col2{font-size:0.32rem;padding: 0.1rem;padding-left: 0.3rem;}
.orderitem-line1-col3{margin-left: auto;}
.badge-grey{border:1px solid #999999;color:#999999;font-size: 0.3rem;padding: 0.1rem;border-radius: 0.1rem;}
.orderitem-line2{display: flex;border-bottom: 1px solid #e7e7e7;align-items: center;padding: 0.3rem;}
.goodsimg{width:2rem;height:2rem;}
.orderitem-line2-col2{display: flex;flex-flow: column nowrap;padding-left: 0.3rem;align-self: flex-start;width:100%;}
.goodstitle{font-size:0.32rem;color:#3c3c3c;text-align: left;}
.goodsparent{font-size:0.3rem;color:#ff3600;text-align: left;padding: 0.15rem 0;}
.orderitem-line33{display: flex;}
.discountinfo{font-size:0.3rem;color:#ff3600;text-align: left;padding: 0.15rem 0;margin-left: auto;margin-right:0.3rem;}
.pricerow{display: flex;margin-top: 0.1rem;}
.price{color:#5e5e5e;font-size:0.32rem;}
.nums{margin-left: auto;font-size:0.32rem;color:#5e5e5e}
.orderitem-line3{display: flex;padding: 0.3rem;}
.orderitem-line3-col2{margin-left: auto;}
.price-red{color:#ff3600;font-size:0.33rem}
.orderitem-line4{display: flex;border-top: 1px solid #e7e7e7;padding: 0.1rem;align-items: center;}
.bottomcon-btn-cancel{background-color:#ccc;color:#333;height:0.8rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-right: 0.1rem;}
.bottomcon-btn-sure{background-color:#ee0a24;color:#fff;height:0.8rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-left: auto;}
.logistic-style{text-align: left;padding-left: 0.15rem;font-size:0.3rem;}
</style>


